module.exports = "/_next/static/images/BadgeEurope@2x-7f5e32b06227e5e5af43e0a6c0c44506.webp";